module.exports = __webpack_public_path__ + "loading-image.78d0e1acfba55a821561afe0852eddbd.hashedasset.svg";